import React, { useRef } from "react";
import { Image } from "react-bootstrap";
import { Challenge } from "@nestcoinco/hyper-api-gateway-api-client";

import "./PendingChallengeListModal.scss";
import ImageCloseIcon from "../../../../images/close-icon-white-rounded.svg";
import ImageSwords from "../../../../images/swords-white.png";
import ImageInfoIcon from "../../../../images/info-white-icon.svg";
import GhostButton from "../../GhostButton/GhostButton";
import BottomDrawer from "../../../BottomDrawer/BottomDrawer";
import HyperBalance from "../../HyperBalance/HyperBalance";
import useBalancesQuery from "../../../../react-query/queries/use-balances";
import Tip from "../../../game-play/Tip/Tip";
import ChallengeCard from "../../ChallengeCard/ChallengeCard";
import { useIsChallengeListModalOpen } from "../../../../jotai/atoms/challenges";
import useIntersectionObserver from "../../../../hooks/useIntersectionObserver";
import { CustomSpinner } from "../../../CustomSpinner/CustomSpinner";

function PendingChallengeListModal({
  pendingChallenges,
  hasNextPage,
  fetchNextPage,
  isFetchingNextPage,
}: {
  pendingChallenges?: Challenge[];
  hasNextPage?: boolean;
  fetchNextPage?: () => void;
  isFetchingNextPage?: boolean;
}) {
  const { hprBalance, isLoading: isBalanceLoading } = useBalancesQuery();
  const { isChallengeListModalOpen, closeChallengeListModal } =
    useIsChallengeListModalOpen();
  const bottomPlaceholderElRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useIntersectionObserver({
    targetRef: bottomPlaceholderElRef,
    options: { threshold: 0.1, root: containerRef.current },
    callback: ([entry]) => {
      entry.isIntersecting && hasNextPage && fetchNextPage?.();
    },
  });

  return (
    <BottomDrawer
      isOpen={isChallengeListModalOpen}
      onClose={closeChallengeListModal}
      showCloseBtn={false}
      containerClass="px-0 pt-0"
    >
      <div className="challenge-list-modal" ref={containerRef}>
        <div className="pb-4 px-3">
          <p className="py-3 d-flex justify-content-between align-items-center px-0">
            <HyperBalance
              balance={hprBalance}
              isLoading={isBalanceLoading}
              style={{ height: 24 }}
              topUpBtnStyle={{ height: 24, width: 24 }}
            />
            <GhostButton
              aria-label="close"
              onClick={closeChallengeListModal}
              style={{ marginRight: -8 }}
            >
              <Image src={ImageCloseIcon} alt="close" width={30} />
            </GhostButton>
          </p>
          <div className="swords-wrapper">
            <Image src={ImageSwords} alt="swords" />
          </div>
          <h2 className="mt-3 mb-2">Challenges</h2>
          <Tip
            icon={<Image alt="" src={ImageInfoIcon} />}
            style={{
              textAlign: "left",
              background: "#161423",
              fontSize: ".75rem",
            }}
          >
            Play your turn before the game expires, or your friend wins and
            takes the reward!
          </Tip>
        </div>
        <div className="card-list py-3 px-3 bg-white">
          {pendingChallenges?.map((challenge) => (
            <ChallengeCard
              key={challenge.id}
              isReducedSize
              challenge={challenge}
            />
          ))}
          <div
            ref={bottomPlaceholderElRef}
            className="d-flex justify-content-center"
            style={{ height: 20 }}
          >
            {isFetchingNextPage && <CustomSpinner size="sm" isPrimary />}
          </div>
        </div>
      </div>
    </BottomDrawer>
  );
}

export default PendingChallengeListModal;
